import React, { useState } from 'react';
import { Menu, Phone, Trash2, X } from 'lucide-react';
import { Button } from '../ui/Button';
const NAV_LINKS = [{
  label: 'Sizes & Pricing',
  href: '#sizes'
}, {
  label: 'How It Works',
  href: '#how-it-works'
}, {
  label: 'Why Greeneway',
  href: '#why-us'
}, {
  label: 'FAQ',
  href: '#faq'
}];
interface HeaderProps {
  onReserve: () => void;
}
export function Header({
  onReserve
}: HeaderProps) {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 w-full border-b border-border bg-background/90 backdrop-blur" data-id="element-198">
      <div className="container flex h-16 items-center justify-between" data-id="element-199">
        <a href="#top" className="flex items-center gap-2" data-id="element-200">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground" data-id="element-201">
            <Trash2 className="h-5 w-5" data-id="element-202" />
          </span>
          <span className="flex flex-col leading-none" data-id="element-203">
            <span className="text-base font-semibold tracking-tight" data-id="element-204">
              Greeneway
            </span>
            <span className="text-xs text-muted-foreground" data-id="element-205">
              Dumpster Rental
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary" data-id="element-206">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="text-sm text-muted-foreground transition-colors hover:text-foreground" data-id="element-207">
              {link.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-3 md:flex" data-id="element-208">
          <a href="tel:+15551234567" className="flex items-center gap-2 text-sm font-medium text-foreground" data-id="element-209">
            <Phone className="h-4 w-4 text-primary" data-id="element-210" />
            (555) 123-4567
          </a>
          <Button onClick={onReserve} data-id="element-211">Reserve a dumpster</Button>
        </div>

        <button type="button" className="inline-flex h-9 w-9 items-center justify-center rounded-md text-foreground md:hidden" onClick={() => setOpen(v => !v)} aria-label="Toggle menu" aria-expanded={open} data-id="element-212">
          {open ? <X className="h-5 w-5" data-id="element-213" /> : <Menu className="h-5 w-5" data-id="element-214" />}
        </button>
      </div>

      {open && <div className="border-t border-border bg-background md:hidden" data-id="element-215">
          <nav className="container flex flex-col py-4" aria-label="Mobile" data-id="element-216">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="py-2 text-sm text-muted-foreground hover:text-foreground" data-id="element-217">
                {link.label}
              </a>)}
            <a href="tel:+15551234567" className="flex items-center gap-2 py-2 text-sm font-medium" data-id="element-218">
              <Phone className="h-4 w-4 text-primary" data-id="element-219" />
              (555) 123-4567
            </a>
            <Button className="mt-3" onClick={() => {
          setOpen(false);
          onReserve();
        }} data-id="element-220">
              Reserve a dumpster
            </Button>
          </nav>
        </div>}
    </header>;
}